import { render } from "./PlanesList.vue?vue&type=template&id=4b5bbef8"
import script from "./PlanesList.vue?vue&type=script&lang=js"
export * from "./PlanesList.vue?vue&type=script&lang=js"

import "./PlanesList.vue?vue&type=style&index=0&id=4b5bbef8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__